const { adminCall } = require("./_utils")

module.exports = {
  create: data => adminCall("invitation.create", data),
  modify: data => adminCall("invitation.modify", data),
  remove: uid => adminCall("invitation.remove", {uid})
}
